// React
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, NavLink } from 'react-router-dom';
import styled from '@emotion/styled';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { Alert, Button } from '@mui/material';
import ConfirmationDialog from '@components/ConfirmationDialog';
import { breadcrumbsActions } from '@store/breadcrumbs';
import { showSuccessMessage, showErrorMessage } from '@store/dashboard';
import { CacheReloadConfigs } from '../../legacy-payment-options.constants';
import { viewCacheReloadModule } from '../../legacy-payment-options.breadcrumbs';
import { reloadCache } from '../../store/legacy-payment-options-cache-reload-module';

const ItemWrapper = styled(NavLink)`
  display: flex;
  box-shadow: 4px 4px 8px #d9d9d9;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  box-sizing: border-box;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 10px;
  margin: 10px;
  min-height: 250px;
  color: #374151;
  cursor: default;
  text-decoration: none;
  height: calc(100% - 20px);

  [class~='title'] {
    word-wrap: break-word;
    word-break: break-word;
    font-weight: 400;
  }

  &:hover {
    box-shadow: 4px 4px 8px #847777;
  }

  [class~='MuiTypography-h6'] {
    font-size: 18px;
  }

  [class~='MuiTypography-subtitle1'] {
    font-size: 11px;
  }
`;

const ButtonWrapper = styled(Button)`
  &:hover {
    background-color: #013c40;
    color: white;
  }
`;

function PaymentMerchantsTiled({ permissions }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const shortForms = {
    PS: 'Payment Service',
    DS: 'Deeplink Service',
  };

  const [data, setData] = useState([]);
  const [selectedService, setSelectedService] = useState({});
  const [showRefreshCacheConfirmation, setShowRefreshCacheConfirmation] =
    useState({ show: false });
  const [alertMessage, setAlertMessage] = useState('');

  useEffect(() => {
    dispatch(breadcrumbsActions.showMenu(true));
    dispatch(breadcrumbsActions.setBreadcrumbs(viewCacheReloadModule));
  }, [dispatch]);

  useEffect(() => {
    setData(CacheReloadConfigs);
  }, []);

  // Authorization
  useEffect(() => {
    if (!permissions?.canCacheReloadModule) {
      navigate('/landing');
    }
  }, [navigate, permissions]);

  const confirmRefreshHandler = (item, selectedItem) => {
    setShowRefreshCacheConfirmation({ show: true });
    setSelectedService(selectedItem);
    setAlertMessage(
      `Are you sure want to Reload ${shortForms[selectedItem.name]} cache for ${
        item.name
      }`,
    );
  };

  const yesConfirmRefreshHandler = () => {
    const body = {
      namespace: selectedService.namespace,
      key: selectedService.value,
    };
    dispatch(reloadCache({ payload: body })).then(({ payload }) => {
      if (payload && payload.status === 'ok') {
        dispatch(showSuccessMessage('Successfully Reloaded Cache'));
      } else {
        dispatch(
          showErrorMessage({
            message: payload.message || 'Error: Something went wrong',
            duration: 4000,
          }),
        );
      }
    });
    setSelectedService({});
  };

  return (
    <div>
      <Alert severity="info">DS = Deeplink service, PS = Payment Service</Alert>
      <Grid
        container
        spacing={2}
        justifyContent="flex-start">
        <ConfirmationDialog
          openDialog={showRefreshCacheConfirmation}
          yesHandler={yesConfirmRefreshHandler}
          title="Reload Cache"
          message={alertMessage}
        />
        {data.map((item) => (
          <Grid
            item
            key={item.name}
            xs={4}
            md={2}
            textAlign="center">
            <ItemWrapper>
              <Typography
                variant="h5"
                className="title"
                gutterBottom
                component="div">
                {item.name}
              </Typography>
              {item.items.map((li) => (
                <ButtonWrapper
                  key={li.name}
                  onClick={() => {
                    confirmRefreshHandler(item, li);
                  }}
                  id="submitBtn"
                  style={{
                    marginTop: '10px',
                    fontSize: '0.7rem',
                    textTransform: 'none',
                  }}
                  fullWidth
                  size="small"
                  variant="outlined"
                  type="submit">
                  {`Reload Cache for ${li.name}`}
                </ButtonWrapper>
              ))}
            </ItemWrapper>
          </Grid>
        ))}
      </Grid>
    </div>
  );
}

export default PaymentMerchantsTiled;
